<template>
  <div class="e1Warp">
    <!-- nav -->
    <versionNav></versionNav>
    <div style="height:106px;width:100%"></div>
    <div class="e4title" ><img src="//cdn1.zygames.com/qqsm/Public/img/version/e1_t.png" width="941" height="128" /></div>
    <!-- <BigPackge></BigPackge> -->
    <saleTime :saleTimeData='saleTime1'></saleTime>
    <saleTime :saleTimeData='saleTime2'></saleTime>
    <saleTime :saleTimeData='saleTime3'></saleTime>
    <!-- <saleTime :saleTimeData='saleTime4'></saleTime> -->
    <!-- <saleTime :saleTimeData='saleTime5'></saleTime> -->
    <!-- <saleTime :saleTimeData='saleTime6'></saleTime> -->
    <!-- <saleTime :saleTimeData='saleTime7'></saleTime> -->
    <!-- <saleTime :saleTimeData='saleTime8'></saleTime> -->
    <!-- <saleTime :saleTimeData='saleTime9'></saleTime> -->
   
    <div class="h50"></div>
  </div>
</template>
<script>
// import BigPackge from "../components/e1_module/BigPackge";
import saleTime from "../components/e1_module/saleTime";
import { mapGetters } from "vuex";
export default {
  name: "e1",
  data(){
    return {
      
    }
  },
  computed:{
    ...mapGetters([
      'saleTime1'
      ,'saleTime2'
      ,'saleTime3'
      // ,'saleTime4'
      // ,'saleTime5'
      // ,'saleTime6'
      // ,'saleTime7'
      // ,'saleTime8'
      // ,'saleTime9'
      ])//如需增加商品就增加一个 saleTime8 与配置表相匹配
  },
  components: {
    // BigPackge,
    saleTime,
  },
  created(){
    
  },
  mounted(){
    
  },
  methods:{

  }
}
</script>

<style lang="scss" scoped>
.e1Warp {
  background: url("//cdn1.zygames.com/qqsm/Public/img/version/bg.jpg") top center;
  .e4title{
    width: 100%;
    height: 200px;
    text-align: center;
    img{
        margin-top: 74px;
    }
  }
  .e1Warp_content{
    color:red;
    font-size: 16px;
    font-weight: bold;
  }
  .h50{
    width: 100%;
    height: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/e1.vue